export default __webpack_public_path__ + "static/media/1917.0c4adbd1.png";